import { Modal } from 'antd';
import React from 'react';
import ModalHeader from './ModalHeader';
import { CloseCircle } from 'iconsax-react';
import classNames from 'classnames';

export default function CustomModal({
  children,
  isOpen,
  open,
  onClose,
  onCancel,
  title,
  subTitle,
  description,
  centered = false,
  closable = true,
  width = 700,
  closeIconClassName,
  bodyStyle,
  withoutLogo,
  variant,
}: {
  children?: React.ReactNode;
  isOpen?: boolean;
  open?: boolean;
  onClose?: () => void;
  onCancel?: () => void;
  title?: string | React.ReactNode;
  subTitle?: string | React.ReactElement;
  description?: string | React.ReactNode;
  centered?: boolean;
  closable?: boolean;
  width?: number | string;
  closeIconClassName?: string;
  withoutLogo?: boolean;
  variant?: 'default' | 'supplier';
  bodyStyle?: React.CSSProperties;
}) {
  const isModalOpen = isOpen || open || false;
  const handleClose = onClose || onCancel;

  return (
    isModalOpen && (
      <Modal
        open={isModalOpen}
        footer={false}
        closable={closable}
        className={classNames(
          'min-w-[715px] [&_.ant-modal-close]:!top-6 [&_.ant-modal-close]:!inset-inline-end-6 [&_.ant-modal-close]:!rounded-full [&_.ant-modal-close]:!w-8 [&_.ant-modal-close]:!h-8 [&_.ant-modal-close]:!bg-[#F9F9F9] [&_.ant-modal-close]:!flex [&_.ant-modal-close]:!items-center [&_.ant-modal-close]:!justify-center [&_.ant-modal-close]:!transition-colors',
          closeIconClassName
        )}
        closeIcon={<CloseCircle size={20} variant="Bold" color="#090909" />}
        bodyStyle={bodyStyle}
        onCancel={(e) => {
          e.stopPropagation();
          handleClose?.();
        }}
        width={width}
        centered={centered}
        styles={{
          content: {
            padding: 0,
            border: document.documentElement.classList.contains('dark')
              ? '1px solid #374151'
              : 'none',
          },
          mask: {
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
          },
        }}
      >
        <div className="modal__container space-y-4 p-[30px]" style={bodyStyle}>
          {title && (
            <ModalHeader
              title={title}
              description={subTitle || description}
              onClose={handleClose}
              closable={false}
              withoutLogo={withoutLogo}
              variant={variant}
            />
          )}
          {children}
        </div>
      </Modal>
    )
  );
}
